import * as React from 'react';

import "foundation-sites/dist/css/foundation.min.css"
import { Redirect, Route } from 'react-router';

import './App.css';
import { Footer } from './components/navigation/Footer';
import { Navbar } from './components/navigation/Navbar';
import { HomeView } from './views/HomeView';
import { ImpressumView } from './views/ImpressumView';
import { InActionView } from './views/InActionView';
import { OrderView } from './views/OrderView';

class App extends React.Component {
  public render() {
    return (
        <div>
            <Navbar />
                <Route path="/home" component={HomeView}/>
                <Route path="/in-action" component={InActionView}/>
                <Route path="/order" component={OrderView}/>
                <Route path="/impressum" component={ImpressumView}/>
                <Redirect from="/" to="/home" />
            <Footer />
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx